/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";
export const Deliver = React.forwardRef<
  SVGSVGElement,
  Omit<React.SVGProps<SVGSVGElement>, "css">
>((props, ref) => (
  <svg
    id="e2b435e2-5181-4ee8-9133-d1c8ba1e35bb"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <defs>
      <style>
        {
          ".bb7357fc-1993-4fd0-9798-a6cf818ed67b,.ecec9182-386f-4d8f-8365-3fbc576a4c2f{fill:none;stroke:#3f20ba;stroke-linecap:round;stroke-linejoin:round;stroke-width:.5px}.ecec9182-386f-4d8f-8365-3fbc576a4c2f{fill:#d9cfff}.b0592a60-91c9-4305-8e4a-9f1bf7ca0875{fill:#3f20ba}"
        }
      </style>
    </defs>
    <path
      fill="#fff"
      d="M12 2.11L3.45 7.05v9.9L12 21.89l8.55-4.94v-9.9L12 2.11z"
    />
    <path
      d="M20.55 7.05v9.9L12 21.89v-9.91l8.55-4.93z"
      className="bb7357fc-1993-4fd0-9798-a6cf818ed67b"
    />
    <path
      d="M20.55 7.05L12 11.98 3.45 7.05 12 2.11l8.55 4.94zM12.94 6.23l3.1-1.79M7.49 9.38l3.09-1.79"
      className="bb7357fc-1993-4fd0-9798-a6cf818ed67b"
    />
    <path
      d="M6.54 5.26l8.55 4.94 2.36-1.37L8.91 3.9 6.54 5.26z"
      className="ecec9182-386f-4d8f-8365-3fbc576a4c2f"
    />
    <path
      d="M17.45 8.83v4.91l-2.36 1.37V10.2l2.36-1.37z"
      className="ecec9182-386f-4d8f-8365-3fbc576a4c2f"
    />
    <path
      d="M12 21.89v-9.91L3.45 7.05v9.9L12 21.89z"
      className="bb7357fc-1993-4fd0-9798-a6cf818ed67b"
    />
    <path
      d="M4.15 17.5L4.4 12l.25 5.46a.25.25 0 0 1-.24.26.24.24 0 0 1-.26-.24zM5.09 18l.25-5.45.25 5.45a.26.26 0 0 1-.24.27.26.26 0 0 1-.26-.24zM6 18.59l.25-5.45.25 5.45a.26.26 0 0 1-.24.26.24.24 0 0 1-.26-.24v-.02zM7 19.13l.25-5.45.25 5.45a.25.25 0 1 1-.5 0zM7.92 19.68l.25-5.45.25 5.45a.24.24 0 0 1-.23.26.26.26 0 0 1-.27-.24zM8.87 20.23l.25-5.46.25 5.46a.25.25 0 0 1-.5 0zM9.81 20.77l.25-5.45.25 5.45a.24.24 0 0 1-.23.26.26.26 0 0 1-.27-.24zM10.76 21.32l.24-5.46.25 5.46a.26.26 0 0 1-.24.26.25.25 0 0 1-.26-.24z"
      className="b0592a60-91c9-4305-8e4a-9f1bf7ca0875"
    />
  </svg>
));
